import { render, staticRenderFns } from "./NuevaSolicitudSection.vue?vue&type=template&id=488d1e2c&scoped=true"
import script from "./NuevaSolicitudSection.vue?vue&type=script&lang=js"
export * from "./NuevaSolicitudSection.vue?vue&type=script&lang=js"
import style0 from "./NuevaSolicitudSection.vue?vue&type=style&index=0&id=488d1e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488d1e2c",
  null
  
)

export default component.exports